import { IStyle } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IProjectDetailsStyles {
  root?: IStyle;
  subTitle?: IStyle;
  description?: IStyle;
  descriptionText?: IStyle;
  list?: IStyle;
  search?: IStyle;
}

export interface IProjectDetailsClassNames {
  root: string;
  subTitle: string;
  description?: string;
  descriptionText?: string;
  list?: string;
  search?: string;
}

export const projectDetailsStylesDefault = (theme: IH2OTheme): Partial<IProjectDetailsStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
  },
  description: {
    color: theme.semanticColors?.textSecondary,
    display: 'flex',
    justifyContent: 'space-between',
  },
  list: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  search: {
    flex: 1,
    marginLeft: 16,
    maxWidth: 611,
  },
  descriptionText: {
    marginTop: 8,
  },
});
